// extracted by mini-css-extract-plugin
export var text = "_1c-0";